import {
    Box,
    Stack,
    Step,
    StepButton,
    StepLabel,
    Stepper,
    Typography,
} from '@mui/material';
import {
    CustomStepConnector,
    CustomStepIcon,
} from 'pages/admin/campaign-data-collect/components/service-payment';
import React, { useState } from 'react';
import SelectObject from './select-object';
import ElectronicInvoice from './electronic-invoice';
import TabPayment from './tab-payment';

const PaymentAdd = () => {
    const steps = ['Chọn đối tượng', 'Hóa đơn điện tử', 'Thanh toán'];
    const [activeStep, setActiveStep] = useState(0);

    const handleStepClick = (index: number) => {
        setActiveStep(index);
    };

    const config: Record<number, React.ReactElement> = {
        0: <SelectObject tabIndex={activeStep} setActiveStep={setActiveStep} />,
        1: (
            <ElectronicInvoice
                tabIndex={activeStep}
                setActiveStep={setActiveStep}
            />
        ),
        2: <TabPayment tabIndex={activeStep} />,
    };
    return (
        <Box mt={5}>
            <Stack direction="row" spacing={2}>
                <Typography
                    variant="h3"
                    component="h3"
                    sx={{
                        fontWeight: '700',
                        fontSize: 28,
                        lineHeight: '33.89px',
                        color: (theme) => theme.palette.primary.main,
                    }}
                >
                    Thêm thanh toán
                </Typography>
            </Stack>
            <Box sx={{ width: '60%', mx: 'auto' }}>
                <Stepper
                    nonLinear
                    activeStep={activeStep}
                    alternativeLabel
                    connector={<CustomStepConnector />}
                    sx={{
                        '.MuiStepLabel-label': {
                            textAlign: 'center',
                            fontSize: '1rem',
                        },
                        '.MuiStepButton-root': {
                            fontSize: '1.2rem',
                        },
                        '.MuiSvgIcon-root': {
                            fontSize: '1.7rem',
                        },
                        '.MuiStepConnector-line': {
                            backgroundColor: 'grey',
                        },
                        '.Mui-active .MuiStepConnector-line': {
                            backgroundColor: 'primary.main',
                        },
                        '.Mui-completed .MuiStepConnector-line': {
                            backgroundColor: 'primary.main',
                        },
                    }}
                >
                    {steps.map((item, index) => (
                        <Step key={index} completed={index < activeStep}>
                            <StepButton
                                disableRipple
                                onClick={() => {
                                    if (index <= activeStep) {
                                        handleStepClick(index);
                                    }
                                }}
                                sx={{
                                    '&.Mui-active': {
                                        color: 'primary.main',
                                    },
                                    '&.Mui-completed': {
                                        color: 'success.main',
                                    },
                                }}
                            >
                                <StepLabel
                                    sx={{
                                        '& .MuiStepLabel-label': {
                                            fontSize: '1.5rem',
                                            fontWeight: 500,
                                        },
                                    }}
                                    StepIconComponent={(props) => (
                                        <CustomStepIcon
                                            {...props}
                                            step={index}
                                        />
                                    )}
                                >
                                    {item}
                                </StepLabel>
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Box>{config[activeStep] || <div>Content not found</div>}</Box>
        </Box>
    );
};

export default PaymentAdd;
